import { httpClient } from '@/services/http/httpClient';
import type { SocialConnection, OAuthConnectResponse } from '@/types';

export const channelsApi = {
  /** GET /api/integrations/social/platforms — returns { platforms: string[] } */
  async getPlatforms() {
    const res = await httpClient.get<{ platforms: string[] }>(
      '/integrations/social/platforms',
    );
    return res.platforms ?? [];
  },

  /** GET /api/integrations/social/connections */
  async getConnections() {
    const res = await httpClient.get<
      SocialConnection[] | { data: SocialConnection[] }
    >('/integrations/social/connections');
    if (Array.isArray(res)) return res;
    if (res && 'data' in res && Array.isArray(res.data)) return res.data;
    return [];
  },

  /** POST /api/integrations/social/connect/:platform — returns { authUrl } */
  async connect(platform: string) {
    return httpClient.post<OAuthConnectResponse>(
      `/integrations/social/connect/${platform}`,
    );
  },

  /** DELETE /api/integrations/social/connections/:platform */
  async disconnect(platform: string) {
    return httpClient.delete(`/integrations/social/connections/${platform}`);
  },
};
